module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Back to top":"Click here to scroll back to top of the page"},"nl":{"Back to top":"Klik hier om naar de bovenkant van de pagina te gaan"}}')
  delete Component.options._Ctor
}
